var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTrash = function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_trash_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_trash_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M6.5 17c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 5 15.5v-10h-.25a.728.728 0 0 1-.534-.214A.72.72 0 0 1 4 4.754c0-.21.072-.39.216-.535A.72.72 0 0 1 4.75 4H8v-.25c0-.212.072-.39.216-.534A.726.726 0 0 1 8.75 3h2.5c.213 0 .39.072.534.216A.726.726 0 0 1 12 3.75V4h3.25c.213 0 .39.071.534.214a.72.72 0 0 1 .216.532c0 .21-.072.39-.216.535a.72.72 0 0 1-.534.219H15v9.991c0 .423-.147.78-.44 1.072A1.45 1.45 0 0 1 13.5 17h-7Zm7-11.5h-7v10h7v-10ZM8.746 14c.21 0 .39-.072.535-.216a.72.72 0 0 0 .219-.534v-5.5a.728.728 0 0 0-.214-.534A.72.72 0 0 0 8.754 7a.734.734 0 0 0-.535.216A.72.72 0 0 0 8 7.75v5.5c0 .213.071.39.214.534a.72.72 0 0 0 .532.216Zm2.5 0c.21 0 .39-.072.535-.216A.72.72 0 0 0 12 13.25v-5.5a.728.728 0 0 0-.214-.534.72.72 0 0 0-.532-.216.734.734 0 0 0-.535.216.72.72 0 0 0-.219.534v5.5c0 .213.072.39.214.534a.72.72 0 0 0 .532.216Z"
  }))));
};
export default SvgIconTrash;